import styles from './styles.module.css'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import { useCreationText } from '../../hooks/useCreationText'

export function BuilderAnswerSwitch({
  subtaskPath,
  numeric = false,
  compact = false,
}: {
  subtaskPath: string
  numeric?: boolean
  compact?: boolean
}) {
  const { control } = useFormContext()
  const t = useCreationText()

  const label = numeric ? t.numericLabel : t.multipleLabel

  return (
    <section className={`${styles.switch}${compact ? ` ${styles.compact}` : ''}`}>
      <div>
        <strong>{label}</strong>
      </div>
      <Controller
        as={ControlledCustomSwitch}
        name={`${subtaskPath}.${numeric ? 'is_numeric' : 'is_multi_choice'}`}
        aria-label={label}
        control={control}
        defaultValue={false}
        valueName="isChecked"
        onChange={([event]) => event.target.checked}
      />
    </section>
  )
}
